// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dvawogvuaomipakwlvst.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR2YXdvZ3Z1YW9taXBha3dsdnN0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgyMTg2NTgsImV4cCI6MjA3Mzc5NDY1OH0.P4I4CuGaJJl4JSlhjJCjUnE2ULPYlPK7igus8OifeO4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});